<div class="home-qa-harness" data-qa="home-qa-harness">
  <div class="home-qa-harness__shell">
    <header class="home-qa-harness__intro">
      <p class="home-qa-harness__eyebrow">{{ lang.translate("home.qaHarness.title") }}</p>
      <h1>{{ lang.translate("home.qaHarness.subtitle") }}</h1>
      <p>{{ lang.translate("home.qaHarness.copy") }}</p>
    </header>

    <section class="qa-section" data-qa="connection-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.connectionEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.connectionTitle") }}</h2>
        </div>
      </div>
      <div class="qa-grid qa-grid--three">
        <article class="qa-card" data-qa="connection-connected">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.connected") }}</p>
          <app-home-decision-pulse-strip [pulse]="pulse" [summary]="summary" [connectionState]="connectedState" [loading]="false" [error]="null"></app-home-decision-pulse-strip>
        </article>

        <article class="qa-card" data-qa="connection-connecting">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.connecting") }}</p>
          <app-home-decision-pulse-strip [pulse]="pulse" [summary]="summary" [connectionState]="connectingState" [loading]="false" [error]="null"></app-home-decision-pulse-strip>
        </article>

        <article class="qa-card" data-qa="connection-error">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.error") }}</p>
          <app-home-decision-pulse-strip [pulse]="pulse" [summary]="summary" [connectionState]="errorState" [loading]="false" [error]="null"></app-home-decision-pulse-strip>
        </article>
      </div>
    </section>

    <section class="qa-section" data-qa="hero-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.heroEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.heroTitle") }}</h2>
        </div>
      </div>
      <div class="qa-grid qa-grid--three">
        <article class="qa-card" data-qa="hero-ready">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.readyHero") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="hero-blocked">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.blockedHero") }}</p>
          <app-home-next-best-decision [nextDecision]="blockedHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="hero-disabled">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.disabledHero") }}</p>
          <app-home-next-best-decision [nextDecision]="disabledHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-next-best-decision>
        </article>
      </div>
    </section>

    <section class="qa-section" data-qa="list-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.listEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.listTitle") }}</h2>
        </div>
      </div>
      <div class="qa-grid qa-grid--two">
        <article class="qa-card qa-card--wide" data-qa="summary-overview">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.summary") }}</p>
          <app-home-decision-summary [summary]="summary" [loading]="false" [error]="null" [activeState]="'all'"></app-home-decision-summary>
        </article>

        <article class="qa-card" data-qa="list-all">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.allDecisions") }}</p>
          <app-home-decision-list [page]="allDecisionsPage" [loading]="false" [error]="null" [activeState]="'all'" [selectedDecisionId]="'decision-blocked'"></app-home-decision-list>
        </article>

        <article class="qa-card" data-qa="list-blocked">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.blockedDecisions") }}</p>
          <app-home-decision-list [page]="blockedDecisionsPage" [loading]="false" [error]="null" [activeState]="'waiting'" [selectedDecisionId]="'decision-blocked'"></app-home-decision-list>
        </article>
      </div>
    </section>

    <section class="qa-section" data-qa="detail-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.detailEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.detailTitle") }}</h2>
        </div>
      </div>
      <div class="qa-grid qa-grid--three">
        <article class="qa-card" data-qa="detail-executable">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.executableDetail") }}</p>
          <app-home-decision-detail [detail]="executableDetail" [loading]="false" [error]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-decision-detail>
        </article>

        <article class="qa-card" data-qa="detail-blocked">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.blockedDetail") }}</p>
          <app-home-decision-detail [detail]="blockedDetail" [loading]="false" [error]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-decision-detail>
        </article>

        <article class="qa-card" data-qa="detail-disabled">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.disabledDetail") }}</p>
          <app-home-decision-detail [detail]="disabledDetail" [loading]="false" [error]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-decision-detail>
        </article>

        <article class="qa-card" data-qa="detail-low-confidence">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.lowConfidenceDetail") }}</p>
          <app-home-decision-detail [detail]="lowConfidenceDetail" [loading]="false" [error]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-decision-detail>
        </article>

        <article class="qa-card" data-qa="detail-form">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.formDetail") }}</p>
          <app-home-decision-detail [detail]="formDetail" [loading]="false" [error]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="null"></app-home-decision-detail>
        </article>
      </div>
    </section>

    <section class="qa-section" data-qa="feedback-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.feedbackEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.feedbackTitle") }}</h2>
        </div>
      </div>
      <div class="qa-grid qa-grid--three">
        <article class="qa-card" data-qa="feedback-loading">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.loadingFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="true" [actionMessage]="null" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-success">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.successFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="stateChangedMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-reevaluation-queued">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.reevaluationFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="blockedHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="reevaluationQueuedMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-inspection-only">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.inspectionFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="feedbackHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="inspectionOnlyMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-business-acknowledged">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.acknowledgedFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="businessAcknowledgedMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-manual-completion">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.manualCompletionFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="manualCompletionMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-replay">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.replayFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="readyHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="replayMessage" [actionError]="null"></app-home-next-best-decision>
        </article>

        <article class="qa-card" data-qa="feedback-error">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.errorFeedback") }}</p>
          <app-home-next-best-decision [nextDecision]="feedbackHero" [loading]="false" [error]="null" [selectedDecisionId]="null" [actionLoading]="false" [actionMessage]="null" [actionError]="actionError"></app-home-next-best-decision>
        </article>
      </div>
    </section>

    <section class="qa-section" data-qa="support-states">
      <div class="qa-section__header">
        <div>
          <p class="qa-section__eyebrow">{{ lang.translate("home.qaHarness.section.supportEyebrow") }}</p>
          <h2>{{ lang.translate("home.qaHarness.section.supportTitle") }}</h2>
        </div>
        <div class="qa-controls">
          <button type="button" class="btn btn-outline-secondary btn-sm" data-qa="toggle-dates" (click)="openDatesPanel()">{{ lang.translate("home.qaHarness.controls.openDates") }}</button>
          <button type="button" class="btn btn-outline-secondary btn-sm" data-qa="toggle-history" (click)="openHistoryPanel()">{{ lang.translate("home.qaHarness.controls.openHistory") }}</button>
          <button type="button" class="btn btn-outline-secondary btn-sm" data-qa="close-panels" (click)="clearSelection()">{{ lang.translate("home.qaHarness.controls.resetPanels") }}</button>
        </div>
      </div>
      <div class="qa-support-grid" data-qa="support-band">
        <article class="qa-card" data-qa="support-dates">
          <app-home-dates-radar [summary]="datesSummary" [loading]="false" [error]="null" [empty]="false" [filterSaving]="false" [filterMessageKey]="null" [filterError]="null"></app-home-dates-radar>
        </article>

        <article class="qa-card" data-qa="support-activity">
          <app-home-last-activity [activity]="activity" [history]="activityHistory" [loading]="false" [error]="null" [empty]="false" [historyLoading]="false" [historyPage]="1" [historyTotalPages]="2"></app-home-last-activity>
        </article>

        <article class="qa-card" data-qa="support-metrics">
          <app-home-stats [metrics]="metrics" [loading]="false" [error]="null" [empty]="false"></app-home-stats>
        </article>
      </div>

      <div class="qa-grid qa-grid--three" data-qa="support-band-empty-states">
        <article class="qa-card" data-qa="support-dates-empty">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.emptyDates") }}</p>
          <app-home-dates-radar [summary]="emptyDatesSummary" [loading]="false" [error]="null" [empty]="true" [filterSaving]="false" [filterMessageKey]="null" [filterError]="null"></app-home-dates-radar>
        </article>

        <article class="qa-card" data-qa="support-activity-empty">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.emptyActivity") }}</p>
          <app-home-last-activity [activity]="null" [history]="emptyActivityHistory" [loading]="false" [error]="null" [empty]="true" [historyLoading]="false" [historyPage]="1" [historyTotalPages]="1"></app-home-last-activity>
        </article>

        <article class="qa-card" data-qa="support-metrics-empty">
          <p class="qa-card__label">{{ lang.translate("home.qaHarness.card.emptyMetrics") }}</p>
          <app-home-stats [metrics]="emptyMetrics" [loading]="false" [error]="null" [empty]="true"></app-home-stats>
        </article>
      </div>
    </section>
  </div>
</div>